// src/hooks/hotelMealPlans/useRestoreHotelMealPlan.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreHotelMealPlan as restoreHotelMealPlanAPI } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useRestoreHotelMealPlan = () => {
    const queryClient = useQueryClient();

    const { mutate: restore, isPending: isRestoring } = useMutation({
        mutationFn: restoreHotelMealPlanAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel meal plan restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore hotel meal plan");
        },
    });

    return { restoreHotelMealPlan: restore, isRestore: isRestoring };
};

export default useRestoreHotelMealPlan;
